import forOwn from 'lodash/forOwn';
import find from 'lodash/find';
/* global MktoForms2 */
// eslint-disable-next-line no-redeclare
/* global pendo */

const MarketoFormMixin = {
    data () {
        return {
            marketoFormSubmitPromise: null,
            marketoFormPromiseSuccess: null,
            formId2: null,
            marketoForm2: null,
            formSuccessCount: 0,
        };
    },
    methods: {
        updateMarketoValue (field) {
            const updating = {};
            updating[field.key] = field.value;
            this.marketoForm.setValues(updating);
            this.marketoForm2?.setValues(updating);
            if (this.submissionTried) {
                this.marketoForm.validate();
            }
        },
        submitFormToMarketo () {
            if (this.marketoForm) {
                this.marketoFormSubmitPromise = new Promise((resolve, reject) => {
                    this.marketoFormPromiseSuccess = resolve;
                    this.marketoForm.setValues({ pendofreesource: this.source });
                    this.marketoForm2?.setValues({ pendofreesource: this.source });
                    this.submissionTried = true;
                    const isFormValid = this.marketoForm.validate();

                    if (isFormValid) {
                        this.marketoForm.submit();
                        this.marketoForm2?.submit();
                    } else {
                        const marketoFormEntries = Object.fromEntries(
                            this.formFields.map((field) => {
                                return [`marketo_${field.key}`, this.marketoForm.getValues()[field.key]];
                            }),
                        );
                        window.pendo.track('Marketo Form submission failed', {
                            ...this.model,
                            ...marketoFormEntries,
                        });
                        reject();
                    }
                });
            }

            return this.marketoFormSubmitPromise;
        },
        onFormSentSuccess () {
            this.formSuccessCount++;

            if (this.marketoFormPromiseSuccess && (!this.formId2 || this.formSuccessCount === 2)) {
                this.marketoFormPromiseSuccess();
            }

            // need to return false so that Marketo doesn't force reload the page!
            return false;
        },
        clearForm () {
            forOwn(this.marketoForm.getValues(), (value, key) => {
                if (key !== 'formid' && key !== 'munchkinId') {
                    const field = {};
                    field[key] = '';
                    this.marketoForm.setValues(field);
                    this.marketoForm2?.setValues(field);
                }
            });
            if (this.acknowledgmentChecked) {
                this.acknowledgmentChecked = false;
            }
            this.formFields = this.parseMarketoFields();
            this.submissionTried = false;
        },
        onValidation () {
            const wrappers = this.getMarketoFieldWrappers();
            for (const wrapper of wrappers) {
                const input = wrapper.getElementsByClassName('mktoField')[0];
                if (input) {
                    const field = find(this.formFields, (field) => field.key === input.name);
                    field.invalid = input.classList.contains('mktoInvalid');
                }
            }
        },
        parseMarketoFields () {
            const fields = [];
            const wrappers = this.getMarketoFieldWrappers();
            for (const wrapper of wrappers) {
                const input = wrapper.getElementsByClassName('mktoField')[0];
                if (input) {
                    const { value, type, name } = input;
                    const required = input.classList.contains('mktoRequired') || this.requiredFieldNames.includes(name);
                    let label = name.replace(/([A-Z])/g, ' $1').trim();
                    let validationMessage;
                    let placeholder = name === 'Company' ? 'Your Company' : `Enter ${label}`;
                    switch (type) {
                        case 'tel':
                            validationMessage = 'Invalid telephone number';
                            placeholder = 'Enter Phone Number';
                            break;
                        case 'email':
                            validationMessage = 'Invalid email address';
                            placeholder = 'name@example.com';
                            break;
                        default:
                            validationMessage = 'Invalid field';
                    }
                    if (required) {
                        label += ' *';
                    }
                    fields.push({
                        key: name,
                        value,
                        type,
                        placeholder,
                        required,
                        label,
                        invalid: false,
                        validation: validationMessage,
                    });
                }
            }

            return fields;
        },
        getMarketoFieldWrappers () {
            return document.querySelectorAll(`#mktoForm_${this.formId} > .mktoFormRow > .mktoFormCol > .mktoFieldWrap`);
        },
        initMarketoScript () {
            return new Promise((resolve, reject) => {
                this.marketoScript = document.createElement('script');
                this.marketoScript.setAttribute('src', 'https://app-ab25.marketo.com/js/forms2/js/forms2.min.js');
                this.marketoScript.async = true;
                this.marketoScript.onload = () => {
                    let form1Initialized = false;
                    let form2Initialized = false;
                    MktoForms2.loadForm('//app-ab25.marketo.com', '185-LQW-370', this.formId, (form) => {
                        this.marketoForm = form;
                        this.formFields = this.parseMarketoFields();
                        form.onSuccess(this.onFormSentSuccess);
                        form.onValidate(this.onValidation);
                        form1Initialized = true;
                        if (!this.formId2 || form2Initialized) {
                            resolve();
                        }
                    });
                    if (this.formId2) {
                        MktoForms2.loadForm('//app-ab25.marketo.com', '185-LQW-370', this.formId2, (form) => {
                            this.marketoForm2 = form;
                            form.onSuccess(this.onFormSentSuccess);
                            form2Initialized = true;
                            if (form1Initialized) {
                                resolve();
                            }
                        });
                    }
                };
                this.marketoScript.onerror = reject;
                document.head.appendChild(this.marketoScript);
            });
        },
        openConfirmationGuide (guideName) {
            const triggerGuide = function () {
                const guide = pendo.findGuideByName(guideName);
                if (!guide) {
                    pendo.events.guidesLoaded(() => {
                        pendo.showGuideByName(guideName);
                    });
                } else {
                    pendo.showGuideByName(guideName);
                }
            };

            if (pendo.isReady()) {
                triggerGuide();
            } else {
                pendo.events.ready(triggerGuide);
            }
        },
    },
};

export default MarketoFormMixin;
